export default __webpack_public_path__ + "static/media/settings-bottom-cloud.3b8fbce4.svg";